<template>
  <div class="tab-content">
    <!-- 文件展示表格 -->
    <el-card style="margin-top:10px; ">
      <el-table
          ref="fileTable"
          :data="commonObjList"
          :key="tableKey"
          style="width: 100%; margin: auto"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :header-cell-style="{ color: 'black' }"
          :height="tableHeight"
      >
        <!-- 选择框 -->
        <el-table-column
            type="selection"
            width="55"
            align="center"
            :selectable="rowSelectable"
        />

        <!-- 文件名称 -->
        <el-table-column
            prop="name"
            label="文件名"
            width="180"
        />

        <!-- 内容类型-->
        <el-table-column
            label="文件标签"
            prop="labels"
            width="180"
            align="left">
        </el-table-column>

        <!-- 文件格式 -->
        <el-table-column
            prop="file_type"
            align="center"
            label="文件格式"
            width="100"
        />

        <!-- 文件大小 -->
        <el-table-column
            prop="file_size"
            align="center"
            label="文件大小"
            width="100"
            :formatter="formatSize"
        />

        <el-table-column label="文件路径">
          <template #default="{ row }">
            <div
                class="file-path-hover"
                @click="openFile(row.file_path)"
                :style="{ cursor: row.file_path ? 'pointer' : 'default' }"
                v-if="row.file_path"
            >
              {{ row.file_path}}
            </div>
            <div v-else> - </div>
          </template>
        </el-table-column>

        <!-- 分析结果列 -->
        <el-table-column label="分析结果" align="center" width="200">
          <template #default="{ row }">
            <!-- 点击触发 -->
            <div
                class="analyse-preview"
                :class="{ 'is-active': currentAnalyseRow && currentAnalyseRow.file_path === row.file_path && popoverVisible }"
                @click.stop="(e) => handleAnalyseClick(e, row)"
            >
              <!-- 翻页指示器 -->
              <span v-if="hasMultipleResults(row)">
                 <el-tag size="small" type="info" style="margin-right: 5px">
                   {{ getCurrentIndex(row) + 1 }}/{{ row.file_pre_analyse.length }}
                 </el-tag>
               </span>
<!--              <span v-if="!getCurrentAnalyseContent(row)" style="color: #ccc;">点击查看</span>-->
              <span>{{ getCurrentAnalyseContent(row) }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="缩略图" width="180">
          <template #default="{ row }">
            <el-image v-if="row.file_image_keys" :src="row.file_image_keys[0]" alt="缩略图" :preview-src-list="row.file_image_keys"
                      style="width: auto; height: 50px;"/>
          </template>
        </el-table-column>

        <el-table-column label="文件状态" align="center" prop="status" width="120">
          <template v-slot="scope">
            <span style="font-size: 13px">{{scope.row.status}}</span>
          </template>
        </el-table-column>

        <el-table-column label="解析状态/操作" align="center" width="120">
          <template v-slot="scope">
            <span v-if="scope.row.status_code >= 399 "
                  style="color: green; font-weight: bold; font-size: 12px ">解析完成</span>
            <span v-else-if="scope.row.status_code > 100" style="font-size: 13px">解析中...</span>
            <el-button
                v-else-if="scope.row.status_code < -100"
                type="danger"
                link
                size="small"
                @click="handleReParse(scope.row)"
            >
              重新解析
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <!-- 全局单例 Popover -->
    <el-popover
        ref="analysePopover"
        :virtual-ref="popoverVirtualRef"
        :visible="popoverVisible"
        virtual-triggering
        placement="left"
        :width="500"
        popper-class="analyse-popper-box"
        :teleported="true"
    >
      <div
          v-if="currentAnalyseRow"
          class="analyse-popover-content"
          v-click-outside="onClickOutside"
      >
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">
          <span style="font-weight: bold; font-size: 14px;">分析详情</span>
          <el-button link size="small" @click="closePopover">关闭</el-button>
        </div>

        <!-- Markdown 内容 -->
        <div
            class="markdown-body"
            v-html="renderMarkdown(getCurrentAnalyseContent(currentAnalyseRow))"
        ></div>

        <!-- 底部翻页控制区 - 使用普通标签替代 el-button 避免 FocusTrap 递归 -->
        <div v-if="hasMultipleResults(currentAnalyseRow)" class="pagination-footer">

          <!-- 上一页图标按钮 -->
          <div
              class="custom-nav-btn"
              :class="{ 'disabled': getCurrentIndex(currentAnalyseRow) === 0 }"
              @click="changeAnalyseIndex(currentAnalyseRow, -1)"
          >
            <el-icon><ArrowLeft /></el-icon>
          </div>

          <span class="page-indicator">
            {{ getCurrentIndex(currentAnalyseRow) + 1 }} / {{ currentAnalyseRow.file_pre_analyse.length }}
          </span>

          <!-- 下一页图标按钮 -->
          <div
              class="custom-nav-btn"
              :class="{ 'disabled': getCurrentIndex(currentAnalyseRow) >= currentAnalyseRow.file_pre_analyse.length - 1 }"
              @click="changeAnalyseIndex(currentAnalyseRow, 1)"
          >
            <el-icon><ArrowRight /></el-icon>
          </div>

        </div>
      </div>
    </el-popover>

  </div>

  <!-- 操作按钮 -->
  <div class="button-container" v-if="!historyMode">
    <el-button type="primary" @click="addImage">添加截图文件</el-button>
    <el-button type="primary" @click="addFile">添加普通文件</el-button>
    <el-button type="warning" @click="go_to_next">查看选中文件</el-button>
  </div>

  <!-- 截图对话框 (保持原样) -->
  <el-dialog v-model="screenshotDialogVisible" title="添加截图文件" width="40%"  @close="cancelAddImage">
    <div v-if="screenshotPreviewUrl">
      <p style="font-weight: bold; margin-bottom: 10px;">图片预览:</p>
      <el-image :src="screenshotPreviewUrl" style="width: auto; height: 300px;"></el-image>

      <p style="font-weight: bold; margin-bottom: 10px;">请选择文件标签:</p>
      <el-checkbox-group v-model="imageClipboardLabels">
        <el-tooltip
            v-for="item in availableLabels"
            :key="item.label"
            :content="item.description"
            placement="top"
        >
          <el-checkbox :label="item.label" border style="margin: 5px;">
            {{ item.label }}
          </el-checkbox>
        </el-tooltip>
      </el-checkbox-group>
    </div>
    <div v-else>
      正在从剪贴板加载图片...
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelAddImage">取消</el-button>
        <el-button type="primary" @click="confirmAddImage">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {ElMessage, ClickOutside} from 'element-plus';
import {mapState} from "vuex";
import {fileReProcess, syncProjectFile} from "@/components/file_process_js/main_process";
import MarkdownIt from 'markdown-it';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'

export default {
  components: {
    ArrowLeft,
    ArrowRight
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      commonObjList: [],
      loading: false,
      selectFilePathMap: {},
      curSelectFilePathMap: {},
      historyMode: false,
      tableHeight: "auto",
      tableKey: 0,
      imageClipboardLabels: [],
      screenshotDialogVisible: false,
      screenshotPreviewUrl: '',
      screenshotData: null,
      isRestoringSelection: false,

      // 修改：关闭 linkify，防止自动识别，虽然主要靠 CSS 禁用
      mdParser: new MarkdownIt({
        html: true,
        breaks: true,
        linkify: false
      }),
      analyseIndexMap: {},

      popoverVirtualRef: null,
      currentAnalyseRow: null,
      popoverVisible: false,
    };
  },

  emits: ["startParse", "changeComponent"],

  computed: {
    ...mapState(['statusChangeSign']),
    availableLabels() {
      return this.$store.state.mainConfig?.labels || [];
    }
  },
  watch: {
    statusChangeSign(currentSign) {
      if (currentSign > 0) {
        this.tableKey = currentSign;
        this.$nextTick(() => {
          this.restoreSelection();
        });
      }
    }
  },

  methods: {
    handleAnalyseClick(event, row) {
      if (this.popoverVisible && this.currentAnalyseRow?.file_path === row.file_path) {
        this.closePopover();
        return;
      }
      this.popoverVirtualRef = event.currentTarget;
      this.currentAnalyseRow = row;
      this.popoverVisible = true;
    },

    onClickOutside() {
      if (this.popoverVisible) {
        this.popoverVisible = false;
      }
    },

    closePopover() {
      this.popoverVisible = false;
    },

    renderMarkdown(text) {
      if (!text) return '<div style="color:#909399; text-align:center">无内容</div>';
      return this.mdParser.render(text);
    },

    getCurrentIndex(row) {
      if (!row) return 0;
      const key = row.file_path;
      return this.analyseIndexMap[key] || 0;
    },

    getCurrentAnalyseContent(row) {
      if (!row) return '';
      const list = Array.isArray(row.file_pre_analyse) ? row.file_pre_analyse : [row.file_pre_analyse];
      const index = this.getCurrentIndex(row);
      return list[index] || '';
    },

    changeAnalyseIndex(row, step) {
      const key = row.file_path;
      const list = Array.isArray(row.file_pre_analyse) ? row.file_pre_analyse : [row.file_pre_analyse];
      const maxIndex = list.length - 1;

      let currentIndex = this.analyseIndexMap[key] || 0;
      let nextIndex = currentIndex + step;

      // 如果超出范围，直接返回，不更新，防止不必要的渲染
      if (nextIndex < 0 || nextIndex > maxIndex) return;

      this.analyseIndexMap = {
        ...this.analyseIndexMap,
        [key]: nextIndex
      };
    },

    hasMultipleResults(row) {
      return Array.isArray(row.file_pre_analyse) && row.file_pre_analyse.length > 1;
    },

    restoreSelection() {
      if (this.$refs.fileTable) {
        this.isRestoringSelection = true;
        this.commonObjList.forEach(row => {
          this.$refs.fileTable.toggleRowSelection(row, row.select);
        });
      }
      this.isRestoringSelection = false;
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear();
      const M = (date.getMonth() + 1).toString().padStart(2, '0');
      const D = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const m = date.getMinutes().toString().padStart(2, '0');
      const s = date.getSeconds().toString().padStart(2, '0');
      return `${Y}${M}${D}_${h}${m}${s}`;
    },
    refreshFileList() {
      this.commonObjList = this.$store.state.commonObjList.concat(this.$store.state.gerberObjList)
      this.$nextTick(() => {
        this.restoreSelection();
      });
    },
    rowSelectable(row) {
      return !this.historyMode;
    },
    async addFile() {
      const newFileList = await this.triggerFileSelect();
      if (!newFileList) return;
      for (const fileAbsPath of newFileList) {
        const existFile = this.commonObjList.find(s => s.file_path === fileAbsPath);
        if (existFile) {
          ElMessage.warning(`文件：${fileAbsPath}已添加，请勿重复添加。`);
          continue
        }
        await syncProjectFile(fileAbsPath, "add");
        this.refreshFileList();
      }
    },
    async addImage() {
      const clipboardData = await this.addFromClipboard();
      if (!clipboardData || !clipboardData.blob) {
        return;
      }
      this.screenshotData = clipboardData;
      this.screenshotPreviewUrl = URL.createObjectURL(clipboardData.blob);
      this.imageClipboardLabels = [];
      this.screenshotDialogVisible = true;
    },
    async confirmAddImage() {
      if (!this.screenshotData) {
        ElMessage.error("截图数据丢失，请重试。");
        this.screenshotDialogVisible = false;
        return;
      }
      const { arrayBuffer, extension } = this.screenshotData;
      const rootPath = this.$store.state.filePath;
      const fileName = `截图_${this.formatTime(Date.now())}.${extension}`;
      try {
        const savedPath = await window.electronAPI.writeFile(rootPath, fileName, arrayBuffer);
        if (savedPath) {
          ElMessage.success(`截图已保存至: ${savedPath}`);
          await syncProjectFile(savedPath, "add", this.imageClipboardLabels);
          this.refreshFileList();
        } else {
          throw new Error("文件保存失败，主进程未返回路径。");
        }
      } catch (error) {
        console.error("保存或同步截图文件失败:", error);
        ElMessage.error(`保存截图失败: ${error.message}`);
      } finally {
        this.cancelAddImage();
      }
    },
    cancelAddImage() {
      this.screenshotDialogVisible = false;
      if (this.screenshotPreviewUrl) {
        URL.revokeObjectURL(this.screenshotPreviewUrl);
      }
      this.screenshotPreviewUrl = '';
      this.screenshotData = null;
    },
    async addFromClipboard() {
      try {
        const clipboardItems = await navigator.clipboard.read();
        const imageItem = clipboardItems.find((item) => item.types.some(type => type.startsWith("image/")));
        if (!imageItem) {
          ElMessage.warning("剪贴板中没有找到图片。");
          return null;
        }
        const imageType = imageItem.types.find(type => type.startsWith("image/"));
        const blob = await imageItem.getType(imageType);
        const extension = imageType.split('/')[1] || 'png';
        const arrayBuffer = await blob.arrayBuffer();
        return { arrayBuffer, extension, blob };
      } catch (error) {
        console.error("从剪贴板添加图片失败:", error);
        ElMessage.error(`无法从剪贴板解析或保存图片！错误信息：${error.message}`);
        return null;
      }
    },
    handleSelectionChange(selectedRows) {
      if (this.isRestoringSelection) return;
      this.commonObjList.map(fileInfo => {
        let tempSelect = false
        for (let i = 0; i < selectedRows.length; i++) {
          if (selectedRows[i]['file_path'] === fileInfo['file_path']) {
            tempSelect = true
            break;
          }
        }
        fileInfo.select = tempSelect
      })
    },
    async go_to_next() {
      this.$store.commit("setSelectFilePathMap", this.selectFilePathMap);
      this.$emit('changeComponent', 1);
      this.$store.commit("addCommonFileChangeSign")
    },
    async triggerFileSelect() {
      return await window.electronAPI.selectFile('file');
    },
    formatSize(row, column, cellValue) {
      if (cellValue == null) return '--';
      return (cellValue / 1024).toFixed(2) + ' KB';
    },
    openFile(filePath) {
      if (filePath) window.electronAPI.openFile(filePath);
    },
    handleReParse(fileInfo) {
      fileReProcess(fileInfo)
    }
  },

  mounted() {
    this.historyMode = this.$route.query.history;
    if (!this.historyMode) {
      this.refreshFileList();
    }
  },
};
</script>

<style>
.el-table__cell {
  position: static !important;
}

.file-path {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
}

.button-container {
  margin-top: 20px;
  text-align: right;
}

.analyse-preview {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
  min-height: 23px;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.analyse-preview:hover {
  background-color: #f5f7fa;
  color: #409EFF;
}

.analyse-preview.is-active {
  background-color: #ecf5ff;
  color: #409EFF;
  font-weight: bold;
}

.analyse-popover-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.markdown-body {
  font-size: 14px;
  line-height: 1.6;
  max-height: 400px;
  overflow-y: auto;
  padding-bottom: 10px;
  color: #2c3e50;
}

/* 【修改重点 1】: 强制禁止 markdown 内部链接点击 */
.markdown-body a {
  pointer-events: none; /* 禁止鼠标事件 */
  cursor: default;      /* 鼠标样式改为普通指针 */
  color: #409EFF;       /* 保留颜色（可选） */
  text-decoration: none;/* 去掉下划线（可选） */
}

.markdown-body h1, .markdown-body h2, .markdown-body h3 {
  margin: 10px 0 5px;
  font-size: 16px;
  border-bottom: 1px solid #eee;
}
.markdown-body ul, .markdown-body ol {
  padding-left: 20px;
  margin: 5px 0;
}
.markdown-body code {
  background: #f4f4f5;
  padding: 2px 4px;
  border-radius: 3px;
  color: #c0392b;
  font-family: monospace;
}
.markdown-body pre {
  background: #f6f8fa;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;
}

.pagination-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #ebeef5;
}

.page-indicator {
  margin: 0 15px;
  font-weight: bold;
  color: #606266;
  font-size: 13px;
  user-select: none;
}

/* 【修改重点 2】: 自定义翻页按钮样式 */
.custom-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  background-color: #f4f4f5;
  color: #606266;
  transition: all 0.3s;
}

.custom-nav-btn:hover:not(.disabled) {
  background-color: #409EFF;
  color: white;
}

.custom-nav-btn.disabled {
  cursor: not-allowed;
  color: #c0c4cc;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
</style>